module.exports = __webpack_public_path__ + "static/img/47_phase_function_Paper_Points.1737fca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/47_phase_function_Paper_Points.png
// module id = fvQA
// module chunks = 0